/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_EMAIL = 'medarbeiderne-minside/Login/CHANGE_EMAIL';
export const CHANGE_PASSWORD = 'medarbeiderne-minside/Login/CHANGE_PASSWORD';
export const CHANGE_SMSCODE = 'medarbeiderne-minside/Login/CHANGE_SMSCODE';

export const LOGOUT = 'medarbeiderne-minside/Login/LOGOUT';

export const CHANGE_LOADING = 'medarbeiderne-minside/Login/CHANGE_LOADING';

export const LOGIN = 'medarbeiderne-minside/Login/LOGIN';
export const LOGIN_SUCCESS = 'medarbeiderne-minside/Login/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'medarbeiderne-minside/Login/LOGIN_FAILURE';
export const LOGIN_SMSCODE_REQUIRED = 'medarbeiderne-minside/Login/LOGIN_SMSCODE_REQUIRED';

export const RESEND_EMAIL_VERIFICATION_CODE = 'medarbeiderne-minside/Login/RESEND_EMAIL_VERIFICATION_CODE';